const initExperienceModal = (root = document) => {
  const dialog = root.querySelector('[data-experience-modal]');
  if (!dialog || dialog.dataset.experienceInit === 'true') return;
  dialog.dataset.experienceInit = 'true';

  const steps = Array.from(dialog.querySelectorAll('.experience-step'));
  const nextButton = dialog.querySelector('[data-experience-next]');
  const backButton = dialog.querySelector('[data-experience-back]');
  const footer = dialog.querySelector('[data-experience-footer]');
  const orderNumber = new URLSearchParams(window.location.search).get('reviewOrder');

  let currentStepIndex = 0;
  let submitted = false;

  const open = () => {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  };

  const close = () => {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  };

  const updateStepVisibility = () => {
    steps.forEach((step, index) => {
      step.classList.toggle('is-active', index === currentStepIndex);
    });

    if (backButton instanceof HTMLButtonElement) {
      backButton.disabled = currentStepIndex === 0;
      backButton.style.display = currentStepIndex === 0 ? 'none' : 'inline-flex';
    }

    if (footer instanceof HTMLElement) {
      footer.style.display = currentStepIndex === steps.length - 1 ? 'none' : 'grid';
    }

    updateNextButtonState();
  };

  const updateNextButtonState = () => {
    if (!(nextButton instanceof HTMLButtonElement)) return;
    const currentStep = steps[currentStepIndex];
    const hasSelection = currentStep?.querySelector('input[type="radio"]:checked');

    if (currentStep?.dataset.step === '2') {
      const isOther = currentStep.querySelector('input[name="exp_source"][value="outro"]')?.checked;
      const otherField = currentStep.querySelector('textarea[name="exp_source_other"]');
      const otherFilled = otherField instanceof HTMLTextAreaElement && otherField.value.trim() !== '';
      nextButton.disabled = !hasSelection || (isOther && !otherFilled);
      return;
    }

    nextButton.disabled = !hasSelection;
  };

  const goNext = () => {
    if (currentStepIndex >= steps.length - 1) return;

    const isLastQuestionStep = currentStepIndex === steps.length - 2;
    if (isLastQuestionStep && !submitted) {
      submitted = true;
      submitExperience();
    }

    currentStepIndex += 1;
    updateStepVisibility();
  };

  const goBack = () => {
    if (currentStepIndex > 0) {
      currentStepIndex -= 1;
      updateStepVisibility();
    }
  };

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });

  dialog.querySelectorAll('[data-experience-close]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      close();
    });
  });

  dialog.addEventListener('change', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.type === 'radio') {
      const isOther =
        event.target.name === 'exp_source' && event.target.value === 'outro' && event.target.checked;
      const stepTwo = dialog.querySelector('.experience-step[data-step="2"]');
      const otherField = stepTwo?.querySelector('textarea[name="exp_source_other"]');

      if (otherField instanceof HTMLTextAreaElement) {
        if (isOther) {
          otherField.classList.remove('is-hidden');
          otherField.setAttribute('required', '');
        } else {
          otherField.classList.add('is-hidden');
          otherField.removeAttribute('required');
          otherField.value = '';
        }
      }

      updateNextButtonState();
    }
  });

  dialog.addEventListener('input', (event) => {
    if (event.target instanceof HTMLTextAreaElement && event.target.name === 'exp_source_other') {
      updateNextButtonState();
    }
  });

  nextButton?.addEventListener('click', goNext);
  backButton?.addEventListener('click', goBack);

  updateStepVisibility();

  window.openExperienceModal = open;
  window.closeExperienceModal = close;

  const submitExperience = async () => {
    if (!orderNumber) {
      console.warn('[experience-modal] Missing reviewOrder query parameter; submission skipped.');
      return;
    }

    const firstPurchase = dialog.querySelector('input[name="exp_first_purchase"]:checked')?.value || '';
    const source = dialog.querySelector('input[name="exp_source"]:checked')?.value || '';
    const sourceOther = dialog.querySelector('textarea[name="exp_source_other"]')?.value?.trim() || '';
    const ease = dialog.querySelector('input[name="exp_ease"]:checked')?.value || '';
    const whatsapp = dialog.querySelector('input[name="exp_whatsapp"]:checked')?.value || '';

    const now = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    const registro = `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()} - ${pad(
      now.getHours()
    )}:${pad(now.getMinutes())}`;

    const width = window.innerWidth || 0;
    const dispositivo = width <= 768 ? 'Mobile' : width <= 1024 ? 'Tablet' : 'Desktop';

    const payload = {
      numero_pedido: String(orderNumber),
      nota: ease ? parseInt(ease, 10) : undefined,
      origem: source ? source : undefined,
      input_origem: source === 'outro' && sourceOther ? sourceOther : undefined,
      registro,
      dispositivo,
      primeira_compra: firstPurchase ? firstPurchase : undefined,
      wpp_contact: whatsapp ? whatsapp : undefined,
    };

    Object.keys(payload).forEach((key) => {
      if (payload[key] === undefined || payload[key] === '') delete payload[key];
    });

    try {
      await fetch('https://melhora.madesa.com:8090/api/avalsite/insert', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
    } catch (error) {
      console.error('[experience-modal] Failed to submit survey:', error);
    }

    // Envia para Google Sheets via App Proxy
    var params = new URLSearchParams(window.location.search);
    var sheetsData = {
      numero_pedido: orderNumber,
      nota: ease,
      primeira_compra: firstPurchase,
      como_conheceu: source,
      whatsapp: whatsapp,
      dispositivo: dispositivo,
      origem: 'pos-compra',
      page_url: window.location.href,
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_term: params.get('utm_term') || '',
      utm_content: params.get('utm_content') || ''
    };

    navigator.sendBeacon(
      '/apps/hub-proxy/api/form-submit',
      new Blob([JSON.stringify(sheetsData)], { type: 'application/json' })
    );
  };

  if (orderNumber) {
    window.addEventListener('load', () => {
      open();
    });
  }
};

document.addEventListener('DOMContentLoaded', () => initExperienceModal());
document.addEventListener('shopify:section:load', (event) => initExperienceModal(event.target));
